import { ReactNode } from 'react';
import { Lock, Trash } from '@phosphor-icons/react';

interface SubjectCardProps {
  subject: {
    id: string | number;
    name: string;
    icon?: string;
    description?: string;
  };
  icon: ReactNode;
  onClick?: () => void;
  onDelete?: (e: React.MouseEvent) => void;
  clickable?: boolean;
  isArchived?: boolean;
}

export default function SubjectCard({ subject, icon, onClick, onDelete, clickable = false, isArchived = false }: SubjectCardProps) {
  const baseClasses = "flex flex-1 gap-3 rounded border p-4 items-center relative";
  const stateClasses = isArchived
    ? "border-gray-700 bg-gray-900/50 cursor-pointer opacity-60"
    : clickable || onClick
    ? "border-border-light bg-input-bg cursor-pointer hover:bg-input-bg/80 transition-colors"
    : "border-border-light bg-input-bg";

  return (
    <div
      className={`${baseClasses} ${stateClasses}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className={isArchived ? "text-gray-600" : "text-white"} data-icon={subject.icon}>
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <h2 className={`text-base font-bold leading-tight truncate ${isArchived ? "text-gray-500" : "text-white"}`}>
          {subject.name}
        </h2>
        {isArchived && (
          <p className="text-gray-600 text-xs leading-tight mt-0.5">Archived</p>
        )}
        {!isArchived && subject.description && (
          <p className="text-text-secondary text-sm leading-tight mt-1">{subject.description}</p>
        )}
      </div>
      {isArchived && (
        <Lock size={16} weight="fill" className="text-gray-600 flex-shrink-0" />
      )}
      {onDelete && (
        <button
          onClick={onDelete}
          title="Delete subject"
          className="ml-1 p-1 rounded border border-gray-700 text-gray-500 hover:text-red-400 hover:bg-red-400/10 hover:border-red-400/30 transition-colors flex-shrink-0"
        >
          <Trash size={14} weight="bold" />
        </button>
      )}
    </div>
  );
}
